import { render } from "./BookingBarEdit.vue?vue&type=template&id=2e846ba7"
import script from "./BookingBarEdit.vue?vue&type=script&lang=js"
export * from "./BookingBarEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingBarEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e846ba7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e846ba7', __exports__)) {
    api.reload('2e846ba7', __exports__)
  }
  
  module.hot.accept("./BookingBarEdit.vue?vue&type=template&id=2e846ba7", () => {
    api.rerender('2e846ba7', render)
  })

}


export default __exports__